import type { SVGProps } from 'react';

export const Favorite = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'favorite'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
      <rect height={32} width={32} x={0} y={0} />
      <path
        d="M16,1 L20.4383508,11.5618031 L32,12.4589803 L23.1814024,19.8837109 L25.8885438,31 L16,25.0269327 L6.11145618,31 L8.81859756,19.8837109 L0,12.4589803 L11.5616492,11.5618031 L16,1 Z M19.2385969,13.223964 L16,5.516 L12.7614031,13.223964 L4.396,13.872 L10.7755981,19.243727 L8.806,27.327 L16,22.9824539 L23.193,27.327 L21.2244019,19.243727 L27.603,13.872 L19.2385969,13.223964 Z"
        fill={props.fill}
      />
    </g>
  </svg>
);
